import { gql } from 'graphql-tag';

export const PageTitleQuery = gql`
	query PageTitleQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			title
		}
	}
`;
